import { STATS_WINDOWS } from '@/api/types'
import type { StatsWindow } from '@/api/types'

/** Vychozi okno, kdyz ho URL neurcuje. */
export const DEFAULT_WINDOW: StatsWindow = '24h'

/**
 * Zvolene okno drzi URL, ne stav komponenty.
 *
 * Diky tomu jde poslat odkaz na konkretni pohled ("kouknej na tenhle cil za
 * 7 dni"), funguje tlacitko zpet a po reloadu zustane vybrane to same okno.
 *
 * Parametr je zamerne volitelny: kdyby byl povinny, musel by ho vyplnit
 * kazdy <Link> na detail cile, a vychozi pohled nema mit v adrese balast.
 * Neznama hodnota se tise zahodi — do URL si kazdy napise, co chce, a
 * stranka kvuli tomu nema spadnout.
 */
export function validateWindowSearch(search: Record<string, unknown>): { window?: StatsWindow } {
  const known = STATS_WINDOWS.find((w) => w === search.window)
  return known ? { window: known } : {}
}
